<template>
  <v-btn-form :title="title" @close="cancel()" listable>
        <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            Экспортируйте акт сверки из 1С программы в XSLX формате и выберите его для загрузки.
          </v-flex>
          <v-layout align-center>
            <v-flex xs8 sm8>
            <template v-for="item in files">
              <div><v-tooltip bottom open-delay="500" max-width="20em">
              <div slot="activator">
              <v-chip
                :key = item.name
                small
                :text-color="errorFileMessage(item) ? 'error' : 'black'"
                @click="pickFile"
                close
                @input="item.remove"
                >
                <span class="text-xs-center">
                  {{item.name.slice(0, 30)}}
                </span>
              </v-chip>
                </div>
                <span style="overflow-wrap: break-word">{{item.name}}</span>
                <div class="error" light>{{errorFileMessage(item)}}</div>
              </v-tooltip></div>
            </template>
            <v-chip
              small
              disabled
              text-color="secondary"
              @click="pickFile"
              v-show="files.length === 0"
              >
              <span class="text-xs-center">
              Выберите файл
              </span>
            </v-chip>
            <input
              type="file"
              style="display: none"
              ref="image"
              @change="onFilePicked"
              :accept="getAcceptedFileFormat()"
              multiple
            >
            </v-flex>
          </v-layout>
        </v-layout>
        <v-flex py-3>
          Проверте соответствие полей документа
        </v-flex>
        <v-layout column>
            <b>
              <v-layout row align-center>
                <v-flex xs3 sm3 >
                <span>Поле</span>
                </v-flex>
                <v-flex xs3 sm4 px-2 >
                <!-- <span>Пример значения</span> -->
                </v-flex>
                <v-flex xs3 sm4 px-2 >
                <!-- <span>Пример значения</span> -->
                </v-flex>
              </v-layout>
            </b>
            <template v-for="field in fields">
              <v-layout row align-center>
              <v-flex v-if = "!field.key" xs3 sm3 >
              <span>{{field.label}}{{field.key ? ' (идентификатор)' : ''}}</span>
              </v-flex>
              <v-flex v-if = "!field.key" xs4 sm4 px-2 >
              <span>{{getValue(field)}}</span>
              </v-flex>
              <v-flex v-if = "!field.key" xs4 sm4 px-2 >
              <span>{{getValue(field, 2)}}</span>
              </v-flex>
              </v-layout>
            </template>
          </v-layout>
      </v-card-text>
      <template #actions>
        <v-btn :disabled='!arrData || arrData.length === 0' @click="ok">ОК</v-btn>
        <v-spacer></v-spacer>
      </template>
    </v-btn-form>  
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import formats from '../../../api/formats'
  import files from '../../../api/files'
  import dialogs from '../../common/dialogs'
  import vBtnForm from '../../common/BtnForm'

  export default {
    name: 'calc-csv1s-loader',
    components: {vBtnForm},
    data: () => ({
      files: [],
      dateFormat: 'DD.MM.YYYY',
      codepage: 'UTF-8',
      // codepage: 'windows-1251',
      textData: null,
      arrData: null
    }),
    watch: {
      textData: function (newVal, oldVal) {
        this.updateArrData()
      },
      codepage: function (newVal, oldVal) {
        this.updateArrData()
      }
    },
    props: {
      fullscreen: {
        type: Boolean,
        default: false
      },
      fields: {
        type: Array,
        default: []
      }
    },
    computed: {
      ...mapGetters({
        calcDialogScroll: 'calcDialogScroll'
      }),
      title () {
        return 'Загрузите данные операций'
      }
    },
    methods: {
      errorFileMessage (file) {
        return files.errorFileMessage(file)
      },
      getAcceptedFileFormat () {
        return '.csv, .xlsx'
      },
      pickFile () {
        this.$refs.image.click()
      },
      onFilePicked (e) {
        const fs = Array.from(e.target.files)
        if (fs.length > 0) {
          fs.forEach((f) => files.readFileAsByteArray(f, (bytes) => {
            this.addFile(f, bytes)
          }))
        }
      },
      addFile (f, data) {
        const cb = (bytes) => {
          f.remove = (e) => !e && this.deleteFile(f)
          this.files = [f]
          this.textData = bytes
        }
        const cbErr = (e) => {
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при экспорте данных из 1С '})
        }
        files.convertToCsv(f, data, cb, cbErr)
      },
      deleteFile (file) {
        this.files = this.files.filter(f => formats.compareString(f.name, file.name) !== 0)
        this.textData = ''
      },
      getValue (field, index) {
        let i = index == null ? 1 : index
        return this.arrData && this.arrData[i] ? this.arrData[i][field.number] : ''
      },
      ok () {
        let result = files.import(this.fields, this.arrData, this.dateFormat)
        if (Object.keys(result).length > 0 && !Object.keys(result)[0]) {
          dialogs.message(this, 'Совет', 'Поле Идентификатора должно быть заполненным')
        } else {
          dialogs.confirm(this,
            'Подтвердите',
            `Загрузить данные об операциях (${Object.keys(result).length})?`,
            (self) => {
              console.log('ok', result)
              this.$emit('change', result)
              this.cancel()
            })
        }
      },
      cancel () {
        this.$emit('close')
        this.item = null
      },
      updateArrData () {
        this.arrData = this.parse1Sformat(files.parseCsv(files.decode(this.textData)))
      },
      parse1Sformat (arrData) {
        let bLine = 0
        let eLine = 0
        let arrTitle = []
        let saldoData = null
        if (arrData) {
          for (var i = 0; i < arrData.length; i++) {
            if (!saldoData) {
              let period = arrData[i].find(s => s.startsWith('за период:'))
              if (period) {
                period = period.match(/(\d{2,2}.\d{2,2}.\d{4,4})/)[0]
                saldoData = period
              }
            }
            if (arrData[i].includes('Дата')) {
              arrTitle = arrData[i]
              this.fields[0].number = arrData[i].indexOf('Документ')
              this.fields[1].number = arrData[i].indexOf('Дата')
              this.fields[2].number = arrData[i].indexOf('Документ')
            }
            if (arrData[i].includes('Дебет')) {
              arrTitle[arrData[i].indexOf('Дебет')] = 'Дебет'
              this.fields[3].number = arrData[i].indexOf('Дебет')
              arrTitle[arrData[i].indexOf('Кредит')] = 'Кредит'
              this.fields[4].number = arrData[i].indexOf('Кредит')
              bLine = i + 1
            }
            if (arrData[i].includes('Сальдо начальное')) {
              arrData[i][this.fields[1].number] = saldoData
            }
            if (arrData[i].includes('Обороты за период')) {
              eLine = i
            }
          }
        }
        let result = []
        result[0] = arrTitle
        result = result.concat(arrData.slice(bLine, eLine))
        return result
      }
    }
  }

</script>




// WEBPACK FOOTER //
// CalcCSV1SLoader.vue?2dbfdd36